import React from 'react';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { useSpring, animated } from 'react-spring/web.cjs'; // web.cjs is required for IE 11 support
import PropTypes from 'prop-types';
import { fade, withStyles } from '@material-ui/core/styles';
import { sortArrayByField } from '../functions/community-operations';

const TransitionComponent = (props) => {
  const style = useSpring({
    from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
};

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 12,
    paddingLeft: 12,
    borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
  },
}))((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

const Tree = ({ array }) => (
  <StyledTreeItem nodeId="-1" label="Заявки на приєднання за областями">
    {array &&
      array.map((region, i) => {
        // sort districts
        sortArrayByField(region.districts, 'districtName');

        return (
          // unique nodeId region
          <StyledTreeItem key={new Date() + Math.random()} nodeId={(i + 1).toString()} label={region.regionName}>
            {region.districts &&
              region.districts.map((district, i1) => {
                // sort communities
                sortArrayByField(district.communities, 'name');

                return (
                  // unique nodeId district
                  <StyledTreeItem
                    key={new Date() + Math.random()}
                    nodeId={((i + 1) * 100 + i1).toString()}
                    label={district.districtName}
                  >
                    {district.communities &&
                      district.communities.map((community, i2) => {
                        return (
                          // unique nodeId
                          <StyledTreeItem
                            key={new Date() + Math.random()}
                            nodeId={((i1 + 1) * 10000 + i2).toString()}
                            label={community.name}
                          >
                            <StyledTreeItem
                              nodeId={((i + 1) * 1000000 + i2).toString()}
                              label={`Дата подачі заявки: ${community.applicationDate}`}
                            />
                          </StyledTreeItem>
                        );
                      })}
                  </StyledTreeItem>
                );
              })}
          </StyledTreeItem>
        );
      })}
  </StyledTreeItem>
);

export default Tree;
